import { useLocation, useNavigate } from "react-router-dom";
import GKButton from "./GKButton";
import { ArrowLeftIcon } from "./Icons";
import { Show } from "./Show";

const CustomeBreadCrumbs = () => {
  const navigate = useNavigate();

  const { pathname } = useLocation();

  const routesData = [
    "/app/dashboard",
    "/app/holdings",
    "/app/imports",
    "/app/crm",
    "/app/equity-basket",
    "/app/reports",
    "/app/insights-holdings",
    "/app/revenue",
    "/app/organisation",
    "/app/company-onboarding",
    "/app/client/equity-basket",
  ];

  return (
    <Show.When isTrue={!routesData.includes(pathname)}>
      <GKButton
        className="outline"
        onClick={() => {
          navigate(-1);
        }}
        startIcon={<ArrowLeftIcon width={16} height={16} />}
      >
        Back
      </GKButton>
    </Show.When>
  );
};

export default CustomeBreadCrumbs;
